import { ResponseState, SearchResult } from '@elastic/search-ui'
import {
  SearchResponseInterface,
  SearchResultInterface,
} from 'common/types/search-interfaces'
import { v4 as uuid } from 'uuid'

export const toResponseState = (
  api: SearchResponseInterface<SearchResultInterface>,
  opts: {
    searchTerm: string
    currentPage: number
    resultsPerPage: number
  },
): ResponseState => {
  const { searchTerm, currentPage, resultsPerPage } = opts

  const totalResults = api.total ?? api.data.length
  const totalPages =
    resultsPerPage > 0 ? Math.ceil(totalResults / resultsPerPage) : 1

  const pagingStart =
    totalResults === 0 ? 0 : (currentPage - 1) * resultsPerPage + 1
  const pagingEnd = Math.min(currentPage * resultsPerPage, totalResults)

  const results: SearchResult[] = api.data.map(item => ({
    id: { raw: String(item.id) },
    type: { raw: item.type },
    path: { raw: item.path },
    name: { raw: item.name },
    description: { raw: item.description },
    content: { raw: item.content },
    image: { raw: item.image },
    publication_date: {
      raw: item.publication_date
        ? new Date(item.publication_date).toISOString()
        : null,
    },
  })) as unknown as SearchResult[]

  return {
    requestId: uuid(),
    facets: {},
    resultSearchTerm: searchTerm,
    totalPages,
    totalResults,
    pagingStart,
    pagingEnd,
    wasSearched: true,
    results,
    rawResponse: api,
  }
}
